import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifierEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token");
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [params]);

  return (
    <div data-testid="verify-email-page" className="min-h-screen flex items-center justify-center px-5 bg-[#050505] grain relative">
      <div className="relative z-10 w-full max-w-md text-center bg-[#121212] border border-white/10 rounded-sm p-10">
        <img src="/logo.png" alt="AS AUTO" className="h-16 w-auto object-contain mx-auto mb-4" />
        {status === "loading" && (
          <><Loader2 className="h-10 w-10 animate-spin text-[#C5A059] mx-auto" /><p className="text-neutral-400 mt-4">Vérification en cours…</p></>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-[#C5A059] mx-auto" />
            <h1 className="font-display text-2xl font-bold text-white mt-4">Adresse confirmée !</h1>
            <p className="text-neutral-400 mt-2">Votre compte est vérifié. Vous pouvez maintenant créer des alertes et suivre vos demandes.</p>
            <Link to="/compte"><Button className="mt-6 bg-[#C5A059] text-black hover:bg-[#E6C678] rounded-sm">Aller à mon compte</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="h-12 w-12 text-[#D92D20] mx-auto" />
            <h1 className="font-display text-2xl font-bold text-white mt-4">Lien invalide ou expiré</h1>
            <p className="text-neutral-400 mt-2">Connectez-vous à votre compte pour renvoyer un e-mail de vérification.</p>
            <Link to="/compte"><Button className="mt-6 bg-[#C5A059] text-black hover:bg-[#E6C678] rounded-sm">Mon compte</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
